import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import DropdownStatus from "./UserStatus";
import SearchBlock from "./SearchBlock";
import "./index.scss";
import { toast } from "react-toastify";

const UserFilterList = ({ filters, clearFilters, selectedDocumentType, _documentTypeEvent, buttonDisabled,disabledButton }) => {

	const [status, setStatus] = useState(null) 
	const [keyword, setKeyword] = useState('')

	/**
     * @description method call to activate or deactivate document types
     * @param {String} type accepting string
     */
	const handleActivateOrDactivateItems = (type) => {
		if (selectedDocumentType.length > 0) {
			_documentTypeEvent(type)
		} else {
			toast.error("kindly select atleast one item to " + type)
		}
	}

	return (
		<>
			<div className="filter-list-blc">
				<h2>
					Apply Filter
				</h2>
				<div className="inner d-flex align-items-center overflow-auto" id="filterListScroll">
					<SearchBlock _keywords={keyword} _handler={(val) => {  setKeyword(val) }} />
					<DropdownStatus status={(val) => { setStatus(val) }} seletedSat={status} />
					<div className="btns-cell d-flex align-items-center">
						<Button disabled={buttonDisabled} color="secondary" onClick={(val) => { filters({ status, keyword }) }}>
							Apply Filter
						</Button>
						<Button color="link" disabled={buttonDisabled}  onClick={(val) => { clearFilters({}); setStatus(null); setKeyword('') }} className="clear-btn d-inline-flex align-items-center">
							<span className="icon d-inline-flex">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="34"
									height="34"
									viewBox="0 0 34 34"
								>
									<g data-name="Group 651" transform="translate(-1535 -134)">
										<g
											fill="#fff"
											stroke="#000"
											strokeWidth="2"
											data-name="Ellipse 30"
											opacity="0.3"
											transform="translate(1535 134)"
										>
											<circle cx="17" cy="17" r="17" stroke="none"></circle>
											<circle cx="17" cy="17" r="16" fill="none"></circle>
										</g>
										<path
											d="M19.589 18l4.8-4.8a1.124 1.124 0 00-1.589-1.584l-4.8 4.8-4.8-4.8a1.124 1.124 0 10-1.584 1.584l4.8 4.8-4.8 4.8a1.124 1.124 0 001.584 1.584l4.8-4.8 4.8 4.8a1.124 1.124 0 101.584-1.584z"
											data-name="Icon ionic-ios-close"
											opacity="0.3"
											transform="translate(1534.289 132.789)"
										></path>
									</g>
								</svg>
							</span>
							Clear Filters
						</Button>
					</div>
				</div>
			</div>
		</>
	);

}
export default UserFilterList;